import component from './vi-VN/component';
import globalHeader from './vi-VN/globalHeader';
import menu from './vi-VN/menu';
import pages from './vi-VN/pages';
import pwa from './vi-VN/pwa';
import settingDrawer from './vi-VN/settingDrawer';
import settings from './vi-VN/settings';

export default {
  'navBar.lang': 'Ngôn ngữ',
  'layout.user.link.help': 'Trợ giúp',
  'layout.user.link.privacy': 'Quyền riêng tư',
  'layout.user.link.terms': 'Điều khoản',
  'transactions.action.clear': 'Xóa',
  'transactions.action.resetFilters': 'Đặt lại bộ lọc',
  'app.preview.down.block': 'Tải trang này về dự án cục bộ',
  'app.welcome.link.fetch-blocks': 'Lấy tất cả block',
  'app.welcome.link.block-list':
    'Nhanh chóng tạo trang chuẩn dựa trên phát triển `block`',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
};
